<template>
    <v-container class="viv-page" grid-list-xl fluid ma-0 pa-0>
      <!-- Success Dialog -->
      <v-dialog v-model="popup" persistent max-width="500px">
        <v-card class="success-dialog glossy-card">
          <v-card-title class="success-title-green">
            <v-icon color="white" size="32" class="mr-2">mdi-check-circle</v-icon>
            <span class="white--text" style="font-style: italic;">Already Enrolled</span>
          </v-card-title>
          <v-card-text class="pt-6 pb-6">
            <p class="mb-0 text-center enrollment-message">Looks like you have already enrolled for this event. Please check your email for payment link and complete your payment.</p>
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="goHome()">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Main Content -->
      <v-row>
        <v-col cols="12">
          <v-card class="main-content-card glossy-card" elevation="8">
            <v-layout justify-center wrap>
              <v-flex xs12 md12>

                <!-- Package Info Box -->
                <v-col cols="12" class="pa-0 package-info-wrapper">
                  <v-card class="package-info-card" elevation="6">
                    <div class="package-info-content">
                      <div class="info-icon-wrapper">
                        <v-icon color="white" size="28">mdi-package-variant</v-icon>
                      </div>
                      <div class="info-text-wrapper">
                        <span class="info-description">
                          The fee includes both <strong>Vazhai Ilai Virundhu</strong> (traditional banana leaf feast) and a <strong>Special Program</strong>. This is an all-inclusive package and items cannot be purchased separately.
                        </span>
                      </div>
                    </div>
                  </v-card>
                </v-col>

                <!-- 3-Step Process Info -->
                <v-col cols="12" class="pa-0 steps-info-wrapper">
                  <v-card class="steps-info-card" elevation="4">
                    <div class="steps-content">
                      <div class="step-item">
                        <div class="step-number">1</div>
                        <div class="step-text">Validating</div>
                      </div>
                      <div class="step-arrow">
                        <v-icon color="#667eea" size="20">mdi-chevron-right</v-icon>
                      </div>
                      <div class="step-item">
                        <div class="step-number">2</div>
                        <div class="step-text">Enrolling</div>
                      </div>
                      <div class="step-arrow">
                        <v-icon color="#667eea" size="20">mdi-chevron-right</v-icon>
                      </div>
                      <div class="step-item">
                        <div class="step-number">3</div>
                        <div class="step-text">Payment</div>
                      </div>
                    </div>
                  </v-card>
                </v-col>

                <!-- Stepper Section with Banners -->
                <v-col cols="12" class="pa-0">
                  <v-row class="ma-0">
                    <!-- Left: Stepper Content -->
                    <v-col cols="12" md="9" class="pa-0">
                      <v-card class="content-section glossy-card pa-0" elevation="0" style="width: 100%; max-width: 100%;">
                        <v-stepper v-model="e6" vertical class="glossy-stepper elevation-0">

                      <!-- Step 1: Validate Membership -->
                      <v-stepper-step :complete="e6 > 1" step="1" editable class="step-header">
                        <span class="step-title">Validate Membership</span>
                        <small class="step-subtitle">Check membership details and reserve your family count for this Event.</small>
                      </v-stepper-step>

                      <v-stepper-content step="1" class="pa-0">
                        <v-card class="step-card glossy-card pa-3 mb-0" elevation="0" flat>
                          <div class="input-wrapper mb-0">
                            <v-text-field
                              name="primaryemail"
                              v-on:keyup="handleInputOnKeyup"
                              :rules="emailRules"
                              label="Primary Member E-mail"
                              background-color="rgba(102, 126, 234, 0.05)"
                              outlined
                              dense
                              id="primaryemail"
                              v-model="Json.primaryemail"
                              type="email"
                              placeholder="Enter your email"
                              required
                              prepend-inner-icon="mdi-email"
                              class="mb-0"
                            ></v-text-field>
                          </div>
                        </v-card>

                        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSignIn" class="mt-0">
                          <div class="button-wrapper">
                            <v-btn
                              color="primary"
                              dark
                              class="validate-btn"
                              @click="checkMembership()"
                              elevation="2"
                              block
                            >
                              <v-icon left>mdi-account-circle</v-icon>
                              Validate Membership
                            </v-btn>
                          </div>
                        </v-form>
                      </v-stepper-content>

                      <!-- Step 2: Enrolling for Event -->
                      <v-stepper-step :complete="e6 > 2" step="2" editable class="step-header">
                        <span class="step-title">Enrolling for Event</span>
                      </v-stepper-step>

                      <v-stepper-content step="2">
                        <v-card class="step-card glossy-card pa-3 mb-2" elevation="3">
                          <!-- Non-Member Section -->
                          <div v-if="this.Json.message ==='No membership data found for the email provided or Payment not done'">
                            <v-alert dense text colored-border color="red" class="mb-2">
                              <v-icon left color="red" size="20">mdi-alert-circle</v-icon>
                              Membership not found for this primary email. You can still reserve your family as non member.
                            </v-alert>

                            <v-layout wrap class="mb-2">
                              <v-flex xs12 md4>
                                <v-text-field
                                  v-if="validatedNonMember"
                                  label="Email"
                                  background-color="rgba(102, 126, 234, 0.05)"
                                  dense
                                  outlined
                                  :rules="emailRules"
                                  v-model="Json.nonMemberEmail"
                                  class="styled-input"
                                  prepend-inner-icon="mdi-email"
                                />
                              </v-flex>
                              <v-flex xs12 md3>
                                <v-text-field
                                  v-if="validatedNonMember"
                                  label="First Name"
                                  dense
                                  outlined
                                  :rules="nameRules"
                                  v-model="Json.firstname"
                                  class="styled-input"
                                  prepend-inner-icon="mdi-account"
                                />
                              </v-flex>
                              <v-flex xs12 md3>
                                <v-text-field
                                  v-if="validatedNonMember"
                                  label="Last Name"
                                  dense
                                  outlined
                                  :rules="nameRules"
                                  v-model="Json.lastname"
                                  class="styled-input"
                                  prepend-inner-icon="mdi-account"
                                />
                              </v-flex>
                            </v-layout>

                            <v-layout wrap class="mb-2">
                              <v-flex xs12 md2>
                                <v-select
                                  v-if="validatedNonMember"
                                  label="Adults Count"
                                  class="styled-input"
                                  dense
                                  outlined
                                  v-model="countJson.adultsCount"
                                  color="primary"
                                  :items="[0, 1, 2, 3, 4, 5]"
                                  prepend-inner-icon="mdi-account-multiple"
                                />
                              </v-flex>
                              <v-flex xs12 md2>
                                <v-select
                                  v-if="validatedNonMember"
                                  label="Kids (5-13 Yrs)"
                                  class="styled-input"
                                  dense
                                  v-model="countJson.KCount"
                                  outlined
                                  color="primary"
                                  :items="[0, 1, 2, 3, 4, 5]"
                                  prepend-inner-icon="mdi-human-child"
                                />
                              </v-flex>
                              <v-flex xs12 md2>
                                <v-select
                                  v-if="validatedNonMember"
                                  label="Parents/Youth"
                                  class="styled-input"
                                  dense
                                  v-model="countJson.PCount"
                                  outlined
                                  color="primary"
                                  :items="[0, 1, 2, 3, 4, 5]"
                                  prepend-inner-icon="mdi-account-group"
                                />
                              </v-flex>
                              <v-flex xs12 md3>
                                <v-select
                                  v-if="validatedNonMember"
                                  label="Preferred TimeSlot for Food"
                                  class="styled-input"
                                  dense
                                  v-model="timeSlot"
                                  outlined
                                  color="primary"
                                  :items="['12.30 PM', '1.15 PM', '2 PM']"
                                  prepend-inner-icon="mdi-clock-outline"
                                />
                              </v-flex>
                              <v-flex xs12 md2>
                                <v-text-field
                                  v-if="validatedNonMember"
                                  class="styled-input"
                                  background-color="rgba(76, 175, 80, 0.1)"
                                  dense
                                  prefix="$"
                                  label="Total Amount"
                                  outlined
                                  v-model="nonMemberAmount"
                                  readonly
                                  prepend-inner-icon="mdi-currency-usd"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>

                            <v-card class="info-card glossy-card pa-2 mb-2" elevation="2">
                              <div class="info-text">
                                <v-icon left color="primary" size="18">mdi-information</v-icon>
                                To take membership for 2026, submit form and complete payment<br />
                                <a href="https://www.charlottetamilsangam.org/#/Register" class="glossy-link">Membership Form</a> |
                                <a href="https://www.charlottetamilsangam.org/#/PaymentGateway" class="glossy-link">Payments</a>
                              </div>
                            </v-card>
                          </div>

                          <!-- Member Section -->
                          <v-container py-0>
                            <v-alert v-if="validatedMember" dense text type="success" class="member-alert">
                              You are a proud member of Charlotte Tamil Sangam.
                            </v-alert>

                            <v-layout wrap class="mb-2">
                              <v-flex xs12 md3>
                                <v-text-field
                                  v-if="validatedMember"
                                  label="First Name"
                                  dense
                                  v-model="Json.firstname"
                                  class="styled-input"
                                  disabled
                                  prepend-inner-icon="mdi-account"
                                />
                              </v-flex>
                              <v-flex xs12 md3>
                                <v-text-field
                                  v-if="validatedMember"
                                  label="Last Name"
                                  dense
                                  v-model="Json.lastname"
                                  class="styled-input"
                                  disabled
                                  prepend-inner-icon="mdi-account"
                                />
                              </v-flex>
                              <v-flex xs12 md3>
                                <v-text-field
                                  v-if="validatedMember"
                                  label="Year"
                                  dense
                                  v-model="Json.year"
                                  class="styled-input"
                                  disabled
                                  prepend-inner-icon="mdi-calendar"
                                />
                              </v-flex>
                              <v-flex xs12 md3>
                                <v-text-field
                                  v-if="validatedMember"
                                  label="Membership"
                                  class="styled-input"
                                  background-color="rgba(76, 175, 80, 0.1)"
                                  dense
                                  v-model="Json.membershipcategory"
                                  disabled
                                  color="primary"
                                  prepend-inner-icon="mdi-card-account-details"
                                />
                              </v-flex>
                            </v-layout>

                            <v-layout wrap class="mb-2">
                              <v-flex xs12 md2>
                                <v-select
                                  v-if="validatedMember"
                                  label="Adults Count"
                                  class="styled-input"
                                  dense
                                  outlined
                                  v-model="countJson.adultsCount"
                                  color="primary"
                                  :items="[0, 1, 2, 3, 4, 5]"
                                  prepend-inner-icon="mdi-account-multiple"
                                />
                              </v-flex>
                              <v-flex xs12 md2>
                                <v-select
                                  v-if="validatedMember"
                                  label="Kids (5-13 Yrs)"
                                  class="styled-input"
                                  dense
                                  v-model="countJson.KCount"
                                  outlined
                                  color="primary"
                                  :items="[0, 1, 2, 3, 4, 5]"
                                  prepend-inner-icon="mdi-human-child"
                                />
                              </v-flex>
                              <v-flex xs12 md2>
                                <v-select
                                  v-if="validatedMember"
                                  label="Parents/Youth"
                                  class="styled-input"
                                  dense
                                  v-model="countJson.PCount"
                                  outlined
                                  color="primary"
                                  :items="[0, 1, 2, 3, 4, 5]"
                                  prepend-inner-icon="mdi-account-group"
                                />
                              </v-flex>
                              <v-flex xs12 md3>
                                <v-select
                                  v-if="validatedMember"
                                  label="Preferred TimeSlot for Food"
                                  class="styled-input"
                                  dense
                                  v-model="timeSlot"
                                  outlined
                                  color="primary"
                                  :items="['11 AM', '11.45 AM', '12.30 PM', '1.15 PM', '2 PM']"
                                  prepend-inner-icon="mdi-clock-outline"
                                />
                              </v-flex>
                              <v-flex xs12 md2>
                                <v-text-field
                                  v-if="validatedMember"
                                  class="styled-input"
                                  background-color="rgba(76, 175, 80, 0.1)"
                                  dense
                                  prefix="$"
                                  label="Total Amount"
                                  outlined
                                  v-model="memberAmount"
                                  readonly
                                  prepend-inner-icon="mdi-currency-usd"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card>

                        <div class="action-buttons mt-4">
                          <v-btn
                            v-if="this.Json.message !=='No membership data found for the email provided or Payment not done'"
                            color="success"
                            dark
                            large
                            elevation="2"
                            @click="submitCount()"
                            class="enroll-btn"
                          >
                            <v-icon left>mdi-check-circle</v-icon>
                            Complete Enrollment
                          </v-btn>

                          <v-btn
                            v-if="this.Json.message ==='No membership data found for the email provided or Payment not done'"
                            color="primary"
                            dark
                            large
                            elevation="2"
                            @click="nonMemberSubmitCount()"
                            class="enroll-btn"
                          >
                            <v-icon left>mdi-check-circle</v-icon>
                            Complete Enrollment
                          </v-btn>
                        </div>
                      </v-stepper-content>

                      <!-- Step 3: Payment Completion -->
                      <v-stepper-step :complete="e6 > 3" step="3" editable class="step-header">
                        <span class="step-title">Payment Completion</span>
                      </v-stepper-step>

                      <v-stepper-content step="3">
                        <v-card class="step-card glossy-card pa-3 mb-2" elevation="3">
                          <div class="payment-summary mb-2">
                            <v-card class="amount-card glossy-card pa-3" elevation="2">
                              <div class="amount-display">
                                <v-icon color="success" size="28" class="mr-2">mdi-currency-usd</v-icon>
                                <div>
                                  <div class="amount-label">Total Amount</div>
                                  <div class="amount-value">
                                    ${{ this.Json.message !== 'No membership data found for the email provided or Payment not done' ? memberAmount : nonMemberAmount }}
                                  </div>
                                </div>
                              </div>
                            </v-card>
                          </div>

                          <v-alert dense text type="info" class="payment-note">
                            <v-icon left color="info" size="18">mdi-information</v-icon>
                            <div>
                              <strong>Note:</strong> You have successfully enrolled for this event. On selecting "Proceed to Pay" button, you will be redirected to Payment page.
                              On that screen update the above displayed amount and complete your payment. You will receive payment confirmation email.
                              <strong>Registration is valid only if payment is complete.</strong>
                            </div>
                          </v-alert>
                        </v-card>

                        <div class="action-buttons">
                          <v-btn
                            v-if="this.Json.message !=='No membership data found for the email provided or Payment not done'"
                            color="success"
                            dark
                            large
                            elevation="2"
                            @click="goToMemberPayments()"
                            class="payment-btn"
                          >
                            <v-icon left>mdi-credit-card</v-icon>
                            Proceed to Pay
                          </v-btn>

                          <v-btn
                            v-if="this.Json.message ==='No membership data found for the email provided or Payment not done'"
                            color="primary"
                            dark
                            large
                            elevation="2"
                            @click="goToNonMemberPayments()"
                            class="payment-btn"
                          >
                            <v-icon left>mdi-credit-card</v-icon>
                            Proceed to Pay
                          </v-btn>
                        </div>
                      </v-stepper-content>
                        </v-stepper>
                      </v-card>
                    </v-col>

                    <!-- Right: Vertical Banners -->
                    <v-col cols="12" md="3" class="banner-column pa-2">
                      <v-card class="banner-vertical-card glossy-card mb-3" elevation="4">
                        <v-img
                          src="https://cltts-gallery.s3.amazonaws.com/events/special2026.jpeg"
                          class="vertical-banner-image"
                          min-height="160"
                          max-height="240"
                        />
                      </v-card>
                      <v-card class="banner-vertical-card glossy-card" elevation="4">
                        <v-img
                          src="https://cltts-gallery.s3.amazonaws.com/events/viv2026.jpeg"
                          class="vertical-banner-image"
                          min-height="160"
                          max-height="240"
                        />
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-flex>
            </v-layout>
          </v-card>
        </v-col>
      </v-row>

      <!-- Sidebar Information -->
      <v-row>
        <v-col cols="12">
          <v-card class="info-sidebar-card glossy-card" elevation="8">
            <v-row>
              <!-- Left Column -->
              <v-col cols="12" md="6">
                <v-expansion-panels v-model="panelLeft" multiple focusable class="glossy-panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="panel-header member-header" dense>
                      <v-icon left color="white" size="20">mdi-account-star</v-icon>
                      <span class="panel-title">For CLTTS Members</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="panel-content">
                      <div class="pricing-item-single-line">
                        <span><v-icon color="primary" size="18">mdi-account</v-icon> Per Adult - <strong>$18</strong></span>
                        <span class="mx-2">•</span>
                        <span><v-icon color="primary" size="18">mdi-human-child</v-icon> Per Kid (5 - 13 Yrs) - <strong>$12</strong></span>
                        <span class="mx-2">•</span>
                        <span><v-icon color="success" size="18">mdi-baby-face</v-icon> Kids under 5 - <strong>Free</strong></span>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header class="panel-header non-member-header" dense>
                      <v-icon left color="white" size="20">mdi-account-multiple</v-icon>
                      <span class="panel-title">For Non-Members</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="panel-content">
                      <div class="pricing-item-single-line">
                        <span><v-icon color="primary" size="18">mdi-account</v-icon> Per Adult - <strong>$25</strong></span>
                        <span class="mx-2">•</span>
                        <span><v-icon color="primary" size="18">mdi-human-child</v-icon> Per Kid (5 - 13 Yrs) - <strong>$15</strong></span>
                        <span class="mx-2">•</span>
                        <span><v-icon color="success" size="18">mdi-baby-face</v-icon> Kids under 5 - <strong>Free</strong></span>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>

              <!-- Right Column -->
              <v-col cols="12" md="6">
                <v-expansion-panels v-model="panelRight" multiple focusable class="glossy-panels">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="panel-header membership-header" dense>
                      <v-icon left color="white" size="20">mdi-card-account-details</v-icon>
                      <span class="panel-title">For Membership</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="panel-content">
                      <div class="membership-links-compact">
                        <span class="links-label">2026 Membership:</span>
                        <a href="https://www.charlottetamilsangam.org/#/Register" class="compact-link" target="_blank">
                          <v-icon size="14">mdi-clipboard-text</v-icon>
                          Form
                        </a>
                        <span class="link-separator">•</span>
                        <a href="https://www.charlottetamilsangam.org/#/PaymentGateway" class="compact-link" target="_blank">
                          <v-icon size="14">mdi-credit-card</v-icon>
                          Payments
                        </a>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel>
                    <v-expansion-panel-header class="panel-header tech-header" dense>
                      <v-icon left color="white" size="20">mdi-help-circle</v-icon>
                      <span class="panel-title">Tech Issues</span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="panel-content">
                      <p>If you are a member and still don't see your data using primary email ID or any technical issues, reach out to Narasimman or
                        <a href="mailto:cltsangam@gmail.com?subject=CLTTS-Membership Issue" class="email-link">TechTeam</a>
                      </p>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  import ReportServices from "@/services/ReportServices"

  export default {
    name: "FullLogin",
    data() {
      return {
        e6: 1,
        panelLeft: [0, 1], // Left column panels expanded by default
        panelRight: [0, 1], // Right column panels expanded by default
        readonly: false,
        popup: false,
        nameRules: [(v) => !!v || "This Field is required"],
        emailRules: [
          (v) => !!v || "Primary E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
          (v)=> !!v || 'Email is required'
        ],
        form: false,
        valid: true,
        text: "",
        Json: {
          primaryemail: "",
        },
        countJson: {
          adultsCount: 0,
          KCount: 0,
          PCount: 0,
          primaryemail: "",
          firstname: "",
          lastname: "",
          membershipcategory: "",
          paymentstatus: "",
          year: "",
          nonMemberEmail: "",
          memberAmount: 0,
          nonMemberAmount: 0,
          timeSlot: "",
        },
        primaryemail: "",
        show3: false,
      };
    },
    computed: {
      formIsValid() {
        return this.primaryemail !== "";
      },
      validatedMember () {
        return (
          this.Json.membershipcategory === "Family" ||
          this.Json.membershipcategory === "Paarivallal" ||
          this.Json.membershipcategory === "Single"
        )
      },
      validatedNonMember () {
        return (
          this.Json.membershipcategory !== "Family" ||
          this.Json.membershipcategory !== "Paarivallal" ||
          this.Json.membershipcategory !== "Single"
        )
      },
      nonMemberAmount() {
        var totalRows = 0;
        totalRows =
          this.countJson.adultsCount * 25 +
          this.countJson.KCount * 15 +
          this.countJson.PCount * 25 
        return totalRows;
      },
      memberAmount() {
        var tRows = 0;
        tRows =
          this.countJson.adultsCount * 18 +
          this.countJson.KCount * 12 +
          this.countJson.PCount * 18 
        return tRows;
      },
    },
    methods: {
      handleInputOnKeyup() {
        this.Json.primaryemail = this.Json.primaryemail.toLowerCase().trim();
      },
      goHome() {
        this.$router.push({ path: "/VIV", replace: true });
        this.popup = false
        this.e6 = 1
      },
      nonMember() {
        this.$router.push({ path: "/NonMemberPayments", replace: true });
      },
      async checkMembership() {
        this.primaryemail = this.Json.primaryemail;
        this.refresh();
        this.e6 = 2
      },
      async nonMemberSubmitCount() {
        this.countJson.primaryemail = this.Json.nonMemberEmail;
        this.countJson.firstname = this.Json.firstname;
        this.countJson.lastname = this.Json.lastname;
        this.countJson.membershipcategory = "NonMember";
        this.countJson.year = "2026";
        this.countJson.checkinstatus = "Y";
        this.countJson.event = "VIV-2026";
        this.countJson.amount = this.nonMemberAmount;
        this.countJson.timeSlot = this.timeSlot;
        this.responseData = await ReportServices.reserveCountForViV(this.countJson)
        if (this.responseData.data === "Already Submitted") {
          this.popup = true;
        } else {
          this.e6 = 3
        }
      },
      goToMemberPayments() {
        window.location.href = "https://cltts.company.site/Chithirai-Thiruvizha-May-31-2026-Food-Tickets-Member-Only-p538561600"
      },
      goToNonMemberPayments() {
        window.location.href = "https://cltts.company.site/Chithirai-Thiruvizha-May-31-2026-Food-Tickets-Non-Member-Only-p538561582"
      },
      async submitCount() {
        this.countJson.primaryemail = this.Json.primaryemail;
        this.countJson.firstname = this.Json.firstname;
        this.countJson.lastname = this.Json.lastname;
        this.countJson.membershipcategory = this.Json.membershipcategory;
        this.countJson.year = this.Json.year;
        this.countJson.paymentstatus = this.Json.paymentstatus;
        this.countJson.checkinstatus = "Y";
        this.countJson.event = "VIV-2026";
        this.countJson.memberid = this.Json._id;
        this.countJson.amount = this.memberAmount;
        this.countJson.timeSlot = this.timeSlot;
        this.responseData = await ReportServices.reserveCountForViV(this.countJson)
        if (this.responseData.data === "Already Submitted") {
          this.popup = true;
        } else {
          this.e6 = 3
        }
      },
      async refresh() {
        this.profileData = await ReportServices.validateMembership(this.primaryemail)
        this.Json = this.profileData.data;
        this.Json.nonMemberEmail = this.primaryemail
      },
    },
    async mounted() {
      this.refresh()
    }
  };
  </script>

  <style lang="scss" scoped>
  // Page Background
  .viv-page {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    min-height: 100vh;
    padding: 4px;
    overflow-x: hidden;
    position: relative;

    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background:
        radial-gradient(circle at 20% 50%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
      pointer-events: none;
      z-index: 0;
    }

    > * {
      position: relative;
      z-index: 1;
    }
  }

  // Glossy Card Effect
  .glossy-card {
    background: rgba(255, 255, 255, 0.95) !important;
    backdrop-filter: blur(10px);
    border-radius: 20px !important;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: translateY(-3px);
    }
  }

  // Enhanced elevation shadows
  .glossy-card[elevation="2"] {
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06),
                0 2px 4px rgba(102, 126, 234, 0.08),
                0 0 0 1px rgba(255, 255, 255, 0.5) inset !important;
  }

  .glossy-card[elevation="3"] {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08),
                0 3px 6px rgba(102, 126, 234, 0.1),
                0 0 0 1px rgba(255, 255, 255, 0.5) inset !important;

    &:hover {
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12),
                  0 6px 12px rgba(102, 126, 234, 0.15),
                  0 0 0 1px rgba(255, 255, 255, 0.7) inset !important;
    }
  }

  .glossy-card[elevation="8"] {
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.14),
                0 8px 16px rgba(102, 126, 234, 0.18),
                0 0 0 1px rgba(255, 255, 255, 0.6) inset !important;

    &:hover {
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.18),
                  0 12px 24px rgba(102, 126, 234, 0.25),
                  0 0 0 1px rgba(255, 255, 255, 0.8) inset !important;
    }
  }

  // Main Content Card
  .main-content-card {
    margin-bottom: 0;
    max-width: 100%;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    padding: 0 !important;
  }

  // Banner Card
  .banner-card {
    overflow: hidden;

    .banner-image {
      transition: transform 0.3s ease;
      width: 100%;
      height: auto;
      max-height: 120px;
      object-fit: cover;
    }

    &:hover .banner-image {
      transform: scale(1.02);
    }
  }

  // Banner Column
  .banner-column {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  // Vertical Banner Cards
  .banner-vertical-card {
    overflow: hidden;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.95) !important;

    .vertical-banner-image {
      transition: transform 0.3s ease;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    &:hover .vertical-banner-image {
      transform: scale(1.02);
    }
  }

  // Content Section
  .content-section {
    background: rgba(255, 255, 255, 0.98) !important;
  }

  // Stepper Styling
  .glossy-stepper {
    background: transparent !important;
    box-shadow: none !important;
    border-left: none !important;

    ::v-deep .v-stepper__step {
      padding: 12px 16px !important;
    }

    ::v-deep .v-stepper__content {
      padding: 12px 16px 16px 16px !important;
      border-left: none !important;
    }

    ::v-deep .v-stepper__wrapper {
      margin-bottom: 8px !important;
    }
  }

  .step-header {
    // Hide the automatic step number prefix (1), 2), 3))
    ::v-deep .v-stepper__step__step {
      display: none !important;
    }

    .step-title {
      font-size: 1rem;
      font-weight: 600;
      color: #667eea;
    }

    .step-subtitle {
      color: #666;
      font-size: 0.85rem;
    }
  }

  .step-card {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    padding: 12px !important;
  }

  // Input and Button Wrappers for Desktop
  .input-wrapper {
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  .button-wrapper {
    width: 100%;
    max-width: 100%;
    display: flex;
    justify-content: flex-start;
  }

  // Info Alert
  .info-alert {
    border-left: 4px solid #2196F3;
    background: linear-gradient(135deg, rgba(33, 150, 243, 0.08), rgba(33, 150, 243, 0.05)) !important;
    margin-bottom: 12px !important;
    padding: 8px 12px !important;
  }

  .member-alert {
    border-left: 4px solid #4CAF50;
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.08), rgba(76, 175, 80, 0.05)) !important;
    margin-bottom: 12px !important;
    padding: 8px 12px !important;
  }

  // Styled Inputs
  .styled-input {
    ::v-deep .v-input__control {
      .v-input__slot {
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
        }
      }
    }
  }

  // Info Card
  .info-card {
    border-left: 5px solid #667eea;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(245, 247, 255, 0.98)) !important;

    .info-text {
      font-size: 0.95rem;
      line-height: 1.6;
      color: #333;
    }
  }

  // Glossy Links
  .glossy-link {
    color: #667eea !important;
    font-weight: 600;
    text-decoration: none;
    padding: 4px 12px;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.15), rgba(118, 75, 162, 0.15));
    border-radius: 6px;
    transition: all 0.3s ease;
    display: inline-block;
    margin: 0 4px;

    &:hover {
      background: linear-gradient(135deg, #667eea, #764ba2);
      color: white !important;
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
    }
  }

  // Action Buttons
  .action-buttons {
    display: flex;
    justify-content: center;
    gap: 12px;
    margin-top: 12px !important;
  }

  .validate-btn,
  .enroll-btn,
  .payment-btn {
    text-transform: none;
    font-weight: 600;
    border-radius: 10px;
    padding: 10px 28px !important;
    font-size: 0.95rem;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }
  }

  // Payment Summary
  .payment-summary {
    .amount-card {
      border-left: 5px solid #4CAF50;
      background: linear-gradient(135deg, rgba(76, 175, 80, 0.08), rgba(76, 175, 80, 0.05)) !important;
    }

    .amount-display {
      display: flex;
      align-items: center;
      justify-content: center;

      .amount-label {
        font-size: 0.9rem;
        color: #666;
        margin-bottom: 4px;
      }

      .amount-value {
        font-size: 2rem;
        font-weight: 700;
        color: #4CAF50;
      }
    }
  }

  .payment-note {
    border-left: 4px solid #2196F3;
    background: linear-gradient(135deg, rgba(33, 150, 243, 0.08), rgba(33, 150, 243, 0.05)) !important;
  }

  // Success Dialog
  .success-dialog {
    border-radius: 16px !important;
    overflow: hidden;

    .success-title {
      background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
      color: white;
      font-size: 1.3rem;
      font-weight: 600;
      padding: 20px 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .success-title-green {
      background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
      color: white;
      font-size: 1.3rem;
      font-weight: 600;
      padding: 20px 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .enrollment-message {
      color: #d3d3d3;
      font-size: 1rem;
      line-height: 1.5;
    }

    .v-card__text {
      padding: 24px;
      font-size: 1rem;
    }

    .v-btn {
      text-transform: none;
      font-weight: 600;
      border-radius: 8px;
    }
  }

  // Info Sidebar Card
  .info-sidebar-card {
    max-width: 100%;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    padding: 0 !important;
  }

  .glossy-panels {
    background: transparent !important;

    .v-expansion-panel {
      background: rgba(255, 255, 255, 0.95) !important;
      margin-bottom: 6px;
      border-radius: 10px !important;
      overflow: hidden;
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
        transform: translateY(-2px);
      }
    }

    ::v-deep .v-expansion-panel-content__wrap {
      padding: 12px 16px !important;
    }
  }

  .panel-header {
    font-weight: 600;
    color: white;
    padding: 10px 16px !important;
    min-height: 48px !important;

    &.member-header {
      background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
    }

    &.non-member-header {
      background: linear-gradient(135deg, #FF9800 0%, #F57C00 100%);
    }

    &.membership-header {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    }

    &.tech-header {
      background: linear-gradient(135deg, #2196F3 0%, #1976D2 100%);
    }

    .panel-title {
      font-size: 0.95rem;
      font-weight: 600;
    }
  }

  .panel-content {
    padding: 12px 16px !important;
    background: rgba(255, 255, 255, 0.98);

    .pricing-item {
      display: flex;
      align-items: center;
      padding: 4px 0;
      font-size: 0.9rem;
      color: #333;

      strong {
        color: #667eea;
      }
    }

    .pricing-item-single-line {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 4px;
      font-size: 0.9rem;
      color: #333;
      line-height: 1.8;

      span {
        display: inline-flex;
        align-items: center;
        gap: 4px;
      }

      strong {
        color: #667eea;
      }

      .v-icon {
        vertical-align: middle;
      }
    }

    .link-buttons {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-top: 8px;
    }

    .info-link-btn {
      display: inline-flex;
      align-items: center;
      padding: 8px 14px;
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.1), rgba(118, 75, 162, 0.1));
      border-radius: 8px;
      color: #667eea;
      text-decoration: none;
      font-weight: 600;
      font-size: 0.9rem;
      transition: all 0.3s ease;
      border: 2px solid rgba(102, 126, 234, 0.2);

      &:hover {
        background: linear-gradient(135deg, #667eea, #764ba2);
        color: white;
        transform: translateX(4px);
        box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
      }
    }

    .email-link {
      color: #667eea;
      font-weight: 600;
      text-decoration: none;
      transition: all 0.3s ease;

      &:hover {
        color: #764ba2;
        text-decoration: underline;
      }
    }

    .membership-links-compact {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
      font-size: 0.9rem;
      line-height: 1.6;

      .links-label {
        font-weight: 600;
        color: #2c3e50;
      }

      .compact-link {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        color: #667eea;
        text-decoration: none;
        font-weight: 600;
        transition: all 0.2s ease;
        padding: 2px 6px;
        border-radius: 4px;

        &:hover {
          color: #764ba2;
          background: rgba(102, 126, 234, 0.1);
          text-decoration: underline;
        }

        .v-icon {
          transition: transform 0.2s ease;
        }

        &:hover .v-icon {
          transform: scale(1.1);
        }
      }

      .link-separator {
        color: #667eea;
        font-weight: 600;
        opacity: 0.5;
      }
    }
  }

  // Responsive Design

  // Large Desktop (1920px and above)
  @media (min-width: 1920px) {
    .viv-page {
      padding: 0;
    }

    .main-content-card {
      max-width: 100%;
      padding: 0 !important;
    }

    .info-sidebar-card {
      max-width: 100%;
      padding: 0 !important;
    }

    .input-wrapper {
      max-width: 30%;
      margin: 0;
    }

    .button-wrapper {
      max-width: 30%;
      margin: 0;
    }
  }

  // Desktop (1280px - 1919px)
  @media (min-width: 1280px) and (max-width: 1919px) {
    .viv-page {
      padding: 0;
    }

    .main-content-card {
      max-width: 100%;
      padding: 0 !important;
    }

    .input-wrapper {
      max-width: 30%;
      margin: 0;
    }

    .button-wrapper {
      max-width: 30%;
      margin: 0;
    }
  }

  // Laptop (1024px - 1279px)
  @media (min-width: 1024px) and (max-width: 1279px) {
    .viv-page {
      padding: 0;
    }

    .main-content-card {
      max-width: 100%;
      padding: 0 !important;
    }

    .banner-card {
      width: 60% !important;
    }

    .event-image-card {
      width: 65% !important;
      max-width: 550px !important;

      .event-image {
        max-height: 280px !important;
      }
    }

    .input-wrapper {
      max-width: 30%;
      margin: 0;
    }

    .button-wrapper {
      max-width: 30%;
      margin: 0;
    }
  }

  // Tablet (768px - 1023px)
  @media (min-width: 768px) and (max-width: 1023px) {
    .viv-page {
      padding: 0;
    }

    .main-content-card {
      max-width: 100%;
      padding: 0 !important;
    }

    .banner-card {
      width: 75% !important;
    }

    .event-image-card {
      width: 75% !important;
      max-width: 500px !important;

      .event-image {
        max-height: 250px !important;
      }
    }

    .step-title {
      font-size: 1rem !important;
    }

    .glossy-card {
      margin-bottom: 6px;
    }
  }

  // Mobile Landscape (600px - 767px)
  @media (min-width: 600px) and (max-width: 767px) {
    .viv-page {
      padding: 2px;
    }

    .banner-card {
      width: 85% !important;
    }

    .event-image-card {
      width: 85% !important;
      max-width: 450px !important;

      .event-image {
        max-height: 220px !important;
      }
    }

    .step-title {
      font-size: 0.95rem !important;
    }
  }

  // Mobile Portrait (below 600px)
  @media (max-width: 599px) {
    * {
      box-sizing: border-box !important;
    }

    .container,
    .v-container {
      padding: 0 !important;
      margin: 0 !important;
      max-width: 100% !important;
      width: 100% !important;
    }

    .viv-page {
      padding: 0 !important;
      margin: 0 !important;
      max-width: 100vw !important;
      width: 100vw !important;
      overflow-x: hidden;

      .v-row {
        margin: 0 !important;
        padding: 0 !important;
      }

      .v-col {
        padding: 0 !important;
        margin: 0 !important;
      }

      .v-layout {
        margin: 0 !important;
        padding: 0 !important;
      }

      .v-flex {
        padding: 0 !important;
        margin: 0 !important;
      }
    }

    .main-content-card {
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      border-radius: 0 !important;
    }

    .banner-card {
      width: 100% !important;
    }

    .event-image-card {
      width: 100% !important;
      max-width: 100% !important;

      .event-image {
        max-height: 200px !important;
      }
    }

    .content-section {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    .banner-vertical-card {
      margin-bottom: 12px !important;
    }

    .glossy-stepper {
      padding: 0 !important;
      margin: 0 !important;

      ::v-deep .v-stepper__step {
        padding: 0 !important;
        margin: 0 !important;
      }

      ::v-deep .v-stepper__content {
        padding: 0 !important;
        margin: 0 !important;
      }

      ::v-deep .v-stepper__wrapper {
        padding: 0 !important;
        margin: 0 !important;
      }
    }

    .step-card {
      padding: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }

    .step-title {
      font-size: 0.9rem !important;
    }

    .step-subtitle {
      font-size: 0.8rem !important;
    }

    .styled-input {
      font-size: 0.9rem !important;
    }

    .v-text-field {
      width: 100% !important;
      max-width: 100% !important;

      ::v-deep .v-input__control {
        width: 100% !important;
      }

      ::v-deep .v-input__slot {
        margin: 0 !important;
        padding: 0 !important;
      }
    }

    .validate-btn,
    .enroll-btn,
    .payment-btn {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
      font-size: 0.85rem !important;
      margin: 0 !important;
      box-sizing: border-box !important;
    }

    .action-buttons {
      flex-direction: column;
      width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    .v-form {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    .amount-value {
      font-size: 1.5rem !important;
    }

    .info-sidebar-card {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    .glossy-card {
      margin-bottom: 0;
      border-radius: 0 !important;
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
    }

    .panel-header {
      padding: 0 !important;

      .panel-title {
        font-size: 0.9rem !important;
      }
    }

    .panel-content {
      padding: 0 !important;

      .pricing-item {
        font-size: 0.85rem !important;
      }

      .pricing-item-single-line {
        font-size: 0.85rem !important;
        gap: 3px;

        .mx-2 {
          margin-left: 0 !important;
          margin-right: 0 !important;
        }
      }

      .membership-links-compact {
        font-size: 0.85rem !important;
        gap: 0;

        .compact-link {
          font-size: 0.85rem !important;
        }
      }
    }

    .glossy-panels {
      .v-expansion-panel {
        margin-bottom: 0 !important;
        border-radius: 0 !important;
      }

      ::v-deep .v-expansion-panel-content__wrap {
        padding: 0 !important;
      }
    }

    .info-alert,
    .member-alert {
      margin: 0 !important;
      padding: 0 !important;
      border-left: 0 !important;
    }

    .input-wrapper,
    .button-wrapper {
      padding: 0 !important;
      margin: 0 !important;
    }

    .payment-summary {
      padding: 0 !important;
      margin: 0 !important;

      .amount-card {
        padding: 0 !important;
        margin: 0 !important;
        border-left: 0 !important;
      }
    }

    .v-card {
      padding: 0 !important;
      margin: 0 !important;
    }

    .v-card__text {
      padding: 0 !important;
    }

    .v-card__actions {
      padding: 0 !important;
    }

    .v-card__title {
      padding: 0 !important;
    }

    // Ensure no horizontal overflow
    .v-stepper__wrapper {
      overflow-x: hidden !important;
      width: 100% !important;
      max-width: 100% !important;
    }

    // Force all child elements to respect container width
    * {
      max-width: 100% !important;
      box-sizing: border-box !important;
    }

    // Add minimal padding to specific info sections for readability
    .package-info-card {
      .package-info-content {
        padding: 8px 12px !important;
      }
    }

    .steps-info-card {
      .steps-content {
        padding: 8px 10px !important;
        gap: 6px !important;

        .step-item {
          gap: 4px !important;

          .step-number {
            width: 24px !important;
            height: 24px !important;
            font-size: 0.8rem !important;
          }

          .step-text {
            font-size: 0.8rem !important;
          }
        }

        .step-arrow {
          .v-icon {
            font-size: 16px !important;
          }
        }
      }
    }

    .step-header {
      padding: 8px 12px !important;

      .step-title {
        font-size: 0.9rem !important;
      }
    }

    .step-card {
      padding: 8px 12px !important;
      border-left-width: 2px !important;
    }
  }

  // Extra Small Mobile (below 400px)
  @media (max-width: 399px) {
    .viv-page {
      padding: 0 !important;
    }

    .main-content-card {
      padding: 0 !important;
    }

    .event-image-card {
      width: 98% !important;

      .event-image {
        max-height: 180px !important;
      }
    }

    .content-section {
      padding: 3px !important;
    }

    .glossy-stepper {
      ::v-deep .v-stepper__step {
        padding: 4px 6px !important;
      }

      ::v-deep .v-stepper__content {
        padding: 2px 6px 6px 6px !important;
      }
    }

    .step-card {
      padding: 4px !important;
    }

    .step-title {
      font-size: 0.85rem !important;
    }

    .amount-value {
      font-size: 1.3rem !important;
    }

    .v-text-field {
      ::v-deep .v-input__slot {
        padding: 0 6px !important;
      }
    }

    .validate-btn,
    .enroll-btn,
    .payment-btn {
      padding: 8px 10px !important;
      font-size: 0.8rem !important;
    }

    .panel-header {
      padding: 6px 8px !important;

      .panel-title {
        font-size: 0.85rem !important;
      }
    }

    .panel-content {
      padding: 6px 8px !important;
    }
  }

  // Package Info Card Styles
  .package-info-card {
    border-radius: 12px !important;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    overflow: hidden;
    width: 100%;
    box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3) !important;

    .package-info-content {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      gap: 12px;

      .info-icon-wrapper {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 50%;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      .info-text-wrapper {
        flex: 1;
        color: white;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
        line-height: 1.5;

        .info-title {
          font-size: 1.05rem;
          font-weight: 700;
          text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
          white-space: nowrap;
        }

        .info-separator {
          font-size: 1.2rem;
          opacity: 0.7;
        }

        .info-description {
          font-size: 0.9rem;
          color: rgba(255, 255, 255, 0.95);
          text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);

          strong {
            color: #ffd700;
            font-weight: 600;
          }
        }
      }
    }
  }

  // 3-Step Process Info Card Styles
  .steps-info-card {
    border-radius: 12px !important;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
    border: 2px solid #667eea;
    width: 100%;

    .steps-content {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 16px;
      gap: 12px;

      .step-item {
        display: flex;
        align-items: center;
        gap: 8px;

        .step-number {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          width: 28px;
          height: 28px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 0.9rem;
          box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
          flex-shrink: 0;
        }

        .step-text {
          font-size: 0.9rem;
          font-weight: 600;
          color: #2c3e50;
          white-space: nowrap;
        }
      }

      .step-arrow {
        display: flex;
        align-items: center;
        flex-shrink: 0;
      }
    }
  }

  @media (max-width: 959px) {
    .package-info-card {
      .package-info-content {
        padding: 10px 14px;

        .info-text-wrapper {
          .info-title {
            font-size: 1rem;
          }

          .info-description {
            font-size: 0.85rem;
          }
        }
      }
    }

    .steps-info-card {
      .steps-content {
        padding: 8px 12px;
        gap: 8px;

        .step-item {
          .step-number {
            width: 26px;
            height: 26px;
            font-size: 0.85rem;
          }

          .step-text {
            font-size: 0.85rem;
          }
        }
      }
    }
  }

  @media (max-width: 599px) {
    // Add spacing to top section wrappers
    .package-info-wrapper {
      margin-top: 12px !important;
      margin-bottom: 12px !important;
    }

    .steps-info-wrapper {
      margin-top: 12px !important;
      margin-bottom: 16px !important;
    }

    .package-info-card {
      border-radius: 0 !important;

      .package-info-content {
        padding: 12px 14px;
        gap: 8px;

        .info-icon-wrapper {
          padding: 0;

          .v-icon {
            font-size: 24px !important;
          }
        }

        .info-text-wrapper {
          gap: 0;

          .info-title {
            font-size: 0.95rem;
            flex-basis: 100%;
          }

          .info-separator {
            display: none;
          }

          .info-description {
            font-size: 0.8rem;
            flex-basis: 100%;
          }
        }
      }
    }

    .steps-info-card {
      border-radius: 0 !important;

      .steps-content {
        flex-wrap: wrap;
        padding: 10px 12px;
        gap: 8px;
        justify-content: space-around;

        .step-item {
          gap: 0;

          .step-number {
            width: 24px;
            height: 24px;
            font-size: 0.8rem;
          }

          .step-text {
            font-size: 0.75rem;
          }
        }

        .step-arrow {
          .v-icon {
            font-size: 16px !important;
          }
        }
      }
    }
  }
  </style>